import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  CustomIntegrationSettingsType,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import usePropertySetting from '../usePropertySetting';

const usePropertyActiveIntegration = ({
  enumId,
  propertyUid,
  pagePropertyUids,
}: {
  enumId: IntegrationEnum;
  propertyUid: string;
  pagePropertyUids: string[];
}) => {
  const { propertySetting, isLoading: isLoadingPropertySetting } =
    usePropertySetting({
      enumId,
      propertyUid,
      pagePropertyUids,
    });

  const { activeAgencyIntegrationSettings, customIntegrationSettings } =
    propertySetting ?? {};

  const connectedIntegrationId = activeAgencyIntegrationSettings?.enumId;
  const hasActiveIntegrationConnected = !!connectedIntegrationId;
  const isConnectedToCurrentIntegration = connectedIntegrationId === enumId;

  // using isInitialLoading to avoid showing the loading indicator when the property is not yet connected to an integration
  const {
    data: activeIntegrationAgencySettings,
    isInitialLoading: isLoadingIntegrationAgencySettings,
  } = useFetchIntegrationAgencySettings({
    enumId: connectedIntegrationId as IntegrationEnum,
    enabled: hasActiveIntegrationConnected,
  });

  const getAccount = () => {
    switch (customIntegrationSettings?.type) {
      case CustomIntegrationSettingsType.STRIPE:
        return customIntegrationSettings?.accountEmail;
      case CustomIntegrationSettingsType.PAYPAL:
        return customIntegrationSettings?.email;
      case CustomIntegrationSettingsType.VACATIONRENTPAYMENT:
        return customIntegrationSettings?.username;
      default:
        return null;
    }
  };

  return {
    hasActiveIntegrationConnected,
    isConnectedToCurrentIntegration,
    account: getAccount(),
    activeIntegration: activeIntegrationAgencySettings?.integration,
    isLoading: isLoadingPropertySetting || isLoadingIntegrationAgencySettings,
  };
};

export default usePropertyActiveIntegration;
